import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const stored = localStorage.getItem("sven-locale") || "zh";

const zh = {
  translation: {
    "app.title": "Sven Admin",
    "nav.overview": "概览",
    "nav.community": "社区",
    "nav.business": "商业",
    "nav.system": "系统",
    "nav.stats": "统计板块",
    "nav.stats-site": "官网统计",
    "nav.stats-desktop": "客户端统计",
    "nav.stats-community": "社区统计",
    "nav.dashboard": "仪表盘",
    "nav.community-users": "用户管理",
    "nav.community-posts": "帖子管理",
    "nav.community-sections": "板块管理",
    "nav.memberships": "套餐管理",
    "nav.orders": "订单管理",
    "nav.crawler": "内容采集",
    "nav.analytics": "数据分析",
    "nav.settings": "系统设置",
    "nav.admin-users": "管理员账号",
    "sign-out": "退出登录",
    theme: "主题",
    "light-mode": "浅色",
    "dark-mode": "深色",
    "system-mode": "跟随系统",
    loading: "加载中...",
    save: "保存",
    cancel: "取消",
    delete: "删除",
    saving: "保存中...",

    // Sections
    "sections.title": "板块管理",
    "sections.desc": "管理社区讨论板块，控制内容分类展示",
    "sections.add": "新建板块",
    "sections.create": "创建",
    "sections.edit": "编辑板块",
    "sections.name": "板块名称",
    "sections.slug": "标识符（Slug）",
    "sections.slug-readonly": "标识符创建后不可修改",
    "sections.description": "描述",
    "sections.description-placeholder": "简短描述该板块的内容...",
    "sections.sort-order": "排序",
    "sections.no-desc": "暂无描述",
    "sections.empty": "暂无板块，点击新建",
    "sections.name-slug-required": "名称和标识符不能为空",
    "sections.created": "板块创建成功",
    "sections.updated": "板块更新成功",
    "sections.deleted": "板块已删除",
    "sections.create-failed": "创建失败",
    "sections.update-failed": "更新失败",
    "sections.delete-failed": "删除失败",
    "sections.delete-title": "确认删除板块？",
    "sections.delete-desc": "删除后数据无法恢复，该板块下的帖子不会被删除。",
    "sections.default-section": "默认板块",
    "sections.select-placeholder": "选择板块（可选）",
    "sections.none": "不指定",
    edit: "编辑",
    create: "新建",
    search: "搜索",
    confirm: "确认",
    actions: "操作",
    status: "状态",
    refresh: "刷新",

    // Login
    "login.title": "后台管理",
    "login.description": "请输入管理员账号登录",
    "login.email": "邮箱",
    "login.email-placeholder": "请输入邮箱地址",
    "login.password": "密码",
    "login.password-placeholder": "请输入密码",
    "login.sign-in": "登录",
    "login.signing-in": "登录中...",
    "login.error-required": "请输入邮箱和密码",
    "login.error-failed": "登录失败",

    // Dashboard
    dashboard: "仪表盘",
    "dashboard.total-users": "总用户数",
    "dashboard.total-posts": "总帖子数",
    "dashboard.admin-count": "管理员数量",
    "dashboard.pending-review": "待审核",
    "dashboard.active-subs": "活跃订阅",
    "dashboard.total-orders": "订单总数",
    "dashboard.pending-orders": "待处理订单",
    "dashboard.mrr": "月重复收入",
    "dashboard.today-pv": "今日 PV",
    "dashboard.crawler-sources": "采集源数量",
    "dashboard.platform-live-overview": "平台实时概览",
    "dashboard.site": "官网",
    "dashboard.desktop": "桌面端",
    "dashboard.community": "社区",
    "dashboard.today-visits": "今日访问",
    "dashboard.unique-ip": "独立IP",
    "dashboard.active-users": "活跃用户",
    "dashboard.launch-count": "次启动",
    "dashboard.sessions": "会话",
    "dashboard.registered": "注册",
    "dashboard.anonymous": "匿名",
    "dashboard.recent-community-posts": "最近社区帖子",
    "dashboard.view-all": "查看全部",
    "dashboard.no-community-posts": "暂无社区帖子",
    "dashboard.recent-orders": "最近订单",
    "dashboard.recent-actions": "最近操作",
    "dashboard.no-orders": "暂无订单",
    "dashboard.no-actions": "暂无操作",
    "dashboard.last-5": "最近 5 条",
    "dashboard.last-10": "最近 10 条",
    "dashboard.no-admin-actions": "暂无管理员操作记录",

    // Community Users
    "community.users.title": "用户管理",
    "community.users.search-placeholder": "搜索用户名或邮箱...",
    "community.users.status": "状态",
    "community.users.all": "全部",
    "community.users.active": "活跃",
    "community.users.banned": "已封禁",
    "community.users.inactive": "未激活",
    "community.users.ban": "封禁",
    "community.users.unban": "解封",
    "community.users.edit": "编辑用户",
    "community.users.role": "角色",
    "community.users.detail": "用户详情",
    "community.users.table-user": "用户",
    "community.users.table-email": "邮箱",
    "community.users.table-role": "角色",
    "community.users.table-status": "状态",
    "community.users.table-posts": "帖子",
    "community.users.table-last-active": "最近活跃",
    "community.users.table-actions": "操作",
    "community.users.no-users": "暂无用户",
    "community.users.no-users-search": "换个搜索词试试",
    "community.users.no-users-yet": "还没有注册用户",
    "community.users.pagination":
      "第 {{page}} 页，共 {{pages}} 页（共 {{total}} 条）",
    "community.users.detail-title": "用户详情",
    "community.users.detail-role": "角色：",
    "community.users.detail-status": "状态：",
    "community.users.detail-posts": "帖子：",
    "community.users.detail-joined": "注册时间：",
    "community.users.detail-bio": "简介",
    "community.users.detail-last-active": "最近活跃：",
    "community.users.detail-never": "从未",
    "community.users.ban-title": "封禁用户",
    "community.users.ban-description": "封禁用户 {name}，限制其在社区的权限。",
    "community.users.ban-duration": "封禁时长（小时）",
    "community.users.ban-duration-hint": "设为 0 表示永久封禁",
    "community.users.ban-reason": "封禁原因",
    "community.users.ban-reason-placeholder": "请输入封禁原因...",
    "community.users.ban-button": "确认封禁",
    "community.users.banning": "封禁中...",
    "community.users.ban-success": "用户已成功封禁",
    "community.users.ban-failed": "封禁用户失败",
    "community.users.unban-success": "用户已成功解封",
    "community.users.unban-failed": "解封用户失败",
    "community.users.load-failed": "加载用户失败",
    "community.users.load-failed-desc": "获取用户列表时发生错误",

    // Community Posts
    "community.posts.title": "帖子管理",
    "community.posts.search-placeholder": "搜索帖子标题...",
    "community.posts.all-status": "全部状态",
    "community.posts.all-sources": "全部来源",
    "community.posts.source-user": "用户",
    "community.posts.source-crawler": "内容采集",
    "community.posts.tag-placeholder": "标签...",
    "community.posts.table-title": "标题",
    "community.posts.table-author": "作者",
    "community.posts.table-tags": "标签",
    "community.posts.table-source": "来源",
    "community.posts.table-status": "状态",
    "community.posts.table-comments": "评论",
    "community.posts.table-date": "日期",
    "community.posts.table-actions": "操作",
    "community.posts.published": "已发布",
    "community.posts.pending": "待审核",
    "community.posts.hidden": "已隐藏",
    "community.posts.deleted": "已删除",
    "community.posts.no-posts": "暂无帖子",
    "community.posts.no-posts-search": "换个搜索词试试",
    "community.posts.no-posts-yet": "还没有创建帖子",
    "community.posts.pagination":
      "第 {{page}} 页，共 {{pages}} 页（共 {{total}} 条）",
    "community.posts.delete-selected": "删除选中 ({{count}})",
    "community.posts.delete": "删除",
    "community.posts.batch-delete": "批量删除",
    "community.posts.notify-author": "通知作者",
    "community.posts.reason": "原因",
    "community.posts.deleting": "删除中...",
    "community.posts.delete-title": "删除帖子",
    "community.posts.delete-desc": "确定要删除该帖子吗？此操作不可撤销。",
    "community.posts.delete-reason": "删除原因（可选）",
    "community.posts.delete-reason-placeholder": "请输入删除原因...",
    "community.posts.delete-button": "确认删除",
    "community.posts.approve": "审核通过",
    "community.posts.reject": "驳回",
    "community.posts.content": "内容",
    "community.posts.no-content": "暂无内容",
    "community.posts.comments": "评论 ({{count}})",
    "community.posts.posted": "发布于",
    "community.posts.untitled": "无标题",
    "community.posts.deleted-success": "帖子已删除",
    "community.posts.delete-failed": "删除帖子失败",
    "community.posts.batch-deleted": "已删除 {{count}} 篇帖子",
    "community.posts.batch-delete-failed": "批量删除失败",

    // Memberships
    "memberships.title": "套餐管理",
    "memberships.create": "新建套餐",
    "memberships.edit": "编辑套餐",
    "memberships.name": "名称",
    "memberships.description": "描述",
    "memberships.monthly": "月付",
    "memberships.quarterly": "季付",
    "memberships.yearly": "年付",
    "memberships.features": "权益",
    "memberships.sort": "排序",
    "memberships.created-success": "套餐创建成功",
    "memberships.updated-success": "套餐更新成功",
    "memberships.deleted-success": "套餐已删除",
    "memberships.name-required": "请输入套餐名称",
    "memberships.new-plan": "新建套餐",
    "memberships.no-plans": "暂无套餐",
    "memberships.create-first": "创建您的第一个会员套餐",
    "memberships.edit-title": "编辑套餐",
    "memberships.create-title": "新建套餐",
    "memberships.edit-desc": "修改套餐信息。",
    "memberships.create-desc": "添加新的会员套餐方案。",
    "memberships.name-label": "套餐名称",
    "memberships.desc-label": "套餐描述",
    "memberships.desc-placeholder": "简要描述套餐内容...",
    "memberships.monthly-label": "月付价格",
    "memberships.quarterly-label": "季付价格",
    "memberships.yearly-label": "年付价格",
    "memberships.sort-label": "排序：{{value}}",
    "memberships.sort-label-form": "排序权重",
    "memberships.features-label": "套餐权益",
    "memberships.features-placeholder": "用逗号分隔，如：高清画质,去广告",
    "memberships.saving": "保存中...",
    "memberships.update-plan": "更新套餐",
    "memberships.create-plan": "创建套餐",
    "memberships.delete-title": "删除套餐",
    "memberships.delete-desc": "确定要删除该套餐吗？此操作不可撤销。",
    "memberships.deleting": "删除中...",
    "memberships.delete-plan": "确认删除",

    // Orders
    "orders.title": "订单管理",
    "orders.all-status": "全部状态",
    "orders.order-id": "订单号",
    "orders.user": "用户",
    "orders.plan": "套餐",
    "orders.amount": "金额",
    "orders.payment": "支付方式",
    "orders.date": "日期",
    "orders.pending": "待支付",
    "orders.paid": "已支付",
    "orders.failed": "失败",
    "orders.refunded": "已退款",
    "orders.no-orders": "暂无订单",
    "orders.no-orders-desc": "用户购买后订单将显示在此处",
    "orders.pagination": "第 {{page}} 页，共 {{pages}} 页（共 {{total}} 条）",
    "orders.refund": "退款",
    "orders.refund-title": "退款确认",
    "orders.refund-desc": "确定要对该订单进行退款吗？金额将退还给用户。",
    "orders.refunding": "退款中...",
    "orders.confirm-refund": "确认退款",
    "orders.refund-success": "退款成功",
    "orders.refund-failed": "退款失败",
    "orders.detail-title": "订单详情",
    "orders.detail-order-id": "订单 ID",
    "orders.detail-user-id": "用户 ID",
    "orders.detail-subscription": "订阅 ID",
    "orders.detail-gateway": "网关交易号",
    "orders.detail-amount": "金额",
    "orders.detail-payment": "支付方式",
    "orders.detail-metadata": "元数据",

    // Crawler
    "crawler.title": "内容采集",
    "crawler.add": "添加数据源",
    "crawler.add-source": "添加数据源",
    "crawler.edit-source": "编辑数据源",
    "crawler.add-desc": "添加新的 RSS/网站数据源进行抓取。",
    "crawler.edit-desc": "修改内容采集数据源配置。",
    "crawler.all-sources": "全部数据源",
    "crawler.enabled": "已启用",
    "crawler.disabled": "已禁用",
    "crawler.no-sources": "暂无内容采集数据源",
    "crawler.no-sources-desc": "添加您的第一个 RSS/网站数据源开始抓取",
    "crawler.run": "立即抓取",
    "crawler.name": "名称",
    "crawler.name-placeholder": "我的博客",
    "crawler.site-url": "站点 URL",
    "crawler.site-url-placeholder": "https://example.com",
    "crawler.rss-url": "RSS URL",
    "crawler.rss-url-placeholder": "https://example.com/feed.xml",
    "crawler.cron": "调度表达式",
    "crawler.cron-placeholder": "0 */6 * * *",
    "crawler.cron-hint": "标准 cron 表达式（如 '0 */6 * * *' 表示每 6 小时）",
    "crawler.tags": "标签",
    "crawler.tags-comma": "标签",
    "crawler.tags-placeholder": "技术, AI, 新闻",
    "crawler.auto-publish": "自动发布",
    "crawler.auto-publish-label": "自动发布抓取内容",
    "crawler.not-run": "尚未运行",
    "crawler.last-run": "上次运行：",
    "crawler.failed-run": "运行失败：",
    "crawler.create-source": "创建数据源",
    "crawler.update-source": "更新数据源",
    "crawler.saving": "保存中...",
    "crawler.delete-source": "删除数据源",
    "crawler.delete-title": "删除数据源",
    "crawler.delete-desc": "确定要删除该内容采集数据源吗？此操作不可撤销。",
    "crawler.deleting": "删除中...",
    "crawler.created": "数据源已创建",
    "crawler.create-failed": "创建数据源失败",
    "crawler.deleted": "数据源已删除",
    "crawler.delete-failed": "删除数据源失败",
    "crawler.started": "抓取已启动",
    "crawler.start-failed": "启动抓取失败",
    "crawler.updated": "数据源已更新",
    "crawler.update-failed": "更新数据源失败",
    "crawler.toggle-failed": "切换状态失败",
    "crawler.name-required": "请输入数据源名称",
    "crawler.total-sources": "数据源总数",
    "crawler.enabled-sources": "启用数据源",
    "crawler.scheduled-next-24h": "24小时内计划执行",
    "crawler.auto-publish-count": "自动发布来源",
    "crawler.scheduler-jobs": "调度任务数",
    "crawler.status-overview": "运行状态概览",
    "crawler.status-running": "运行中",
    "crawler.status-success": "成功",
    "crawler.status-failed": "失败",
    "crawler.status-never": "未执行",
    "crawler.scheduler-status": "调度器状态",
    "crawler.running": "运行中",
    "crawler.stopped": "已停止",
    "crawler.cron-validity": "有效调度表达式",
    "crawler.upcoming-runs": "即将执行",
    "crawler.no-upcoming-runs": "暂无即将执行的任务",
    "crawler.injected-posts": "最近注入社区内容",
    "crawler.no-injected-posts": "暂无内容采集注入的社区内容",
    "crawler.open-community": "打开社区",
    "crawler.run-and-open": "执行并打开社区",
    "crawler.biz-jobs": "内容采集业务任务",
    "crawler.no-jobs": "暂无可用业务任务",
    "crawler.add-job": "新建任务",
    "crawler.edit-job": "编辑任务",
    "crawler.job-created": "任务已创建",
    "crawler.job-deleted": "任务已删除",
    "crawler.job-create-failed": "创建任务失败",
    "crawler.job-delete-failed": "删除任务失败",
    "crawler.delete-job-title": "确认删除业务任务？",
    "crawler.delete-job-desc": "删除后无法恢复，任务的历史记录将一并清除。",
    "crawler.description": "描述",
    "crawler.description-placeholder": "任务用途说明（可选）",
    "crawler.save-schedule": "保存定时",
    "crawler.view-last-post": "查看上次结果",
    "crawler.cron-required": "请输入定时表达式",
    "crawler.section-usage": "采集资讯板块使用分布",
    "crawler.section-usage-desc": "基于最近 {{count}} 条采集注入帖子统计",
    "crawler.no-section-usage": "暂无可统计的板块数据",
    "crawler.section-unassigned": "未分配板块",
    "crawler.source-usage": "采集来源分布",
    "crawler.source-usage-desc": "基于最近 {{count}} 条采集注入帖子统计",
    "crawler.no-source-usage": "暂无可统计的来源数据",
    "crawler.source-unknown": "未知来源",
    "crawler.section-count-posts": "{{count}} 条",
    "crawler.section-latest": "最近：",
    "crawler.job-target-sections": "关联板块",
    "crawler.job-target-sections-empty": "暂无可识别的板块",
    "crawler.job-strategy-tip":
      "策略说明：业务任务会按你勾选的板块直接投递；未勾选时默认投递到技术板块。",
    "crawler.job-target-sections-edit": "点击下方板块进行编辑：",
    "crawler.job-target-sections-loading": "正在加载社区板块...",
    "crawler.save-target-sections": "保存板块",
    "crawler.select-all-sections": "全选",
    "crawler.clear-sections": "清空",

    // Analytics
    "analytics.title": "数据分析",
    "analytics.total-pv": "总 PV",
    "analytics.total-downloads": "总下载",
    "analytics.pv-today": "今日 PV",
    "analytics.downloads-today": "今日下载",
    "analytics.page-views": "页面访问",
    "analytics.downloads": "下载",
    "analytics.top-pages": "热门页面",
    "analytics.sources": "来源",
    "analytics.daily-pv": "每日页面访问量",
    "analytics.no-data": "暂无数据",
    "analytics.no-download-data": "暂无下载数据",
    "analytics.traffic-sources": "流量来源",
    "analytics.downloads-by-platform": "各平台下载量",
    "analytics.downloads-by-day": "每日下载量",

    // Settings
    "settings.title": "系统设置",
    "settings.save": "保存设置",
    "settings.saved": "设置已保存",
    "settings.saving": "保存中...",
    "settings.save-changes": "保存更改",
    "settings.load-failed": "加载设置失败",
    "settings.site": "站点设置",
    "settings.site-name": "站点名称",
    "settings.site-name-placeholder": "Sven Studio",
    "settings.registration": "用户注册",
    "settings.registration-desc": "允许新用户注册",
    "settings.review": "帖子审核",
    "settings.review-desc": "发布前需管理员审核",
    "settings.email": "邮件设置",
    "settings.email-title": "邮件（SMTP）设置",
    "settings.smtp-host": "SMTP 主机",
    "settings.smtp-host-placeholder": "smtp.example.com",
    "settings.smtp-port": "SMTP 端口",
    "settings.smtp-user": "SMTP 用户",
    "settings.smtp-user-placeholder": "user@example.com",
    "settings.smtp-pass": "SMTP 密码",
    "settings.smtp-pass-placeholder": "请输入密码",
    "settings.from-address": "发件地址",
    "settings.from-address-placeholder": "noreply@example.com",
  },
};

const en: typeof zh = {
  translation: {
    "app.title": "Sven Admin",
    "nav.overview": "Overview",
    "nav.community": "Community",
    "nav.business": "Business",
    "nav.system": "System",
    "nav.stats": "Statistics",
    "nav.stats-site": "Site Stats",
    "nav.stats-desktop": "Desktop Stats",
    "nav.stats-community": "Community Stats",
    "nav.dashboard": "Dashboard",
    "nav.community-users": "Users",
    "nav.community-posts": "Posts",
    "nav.community-sections": "Sections",
    "nav.memberships": "Memberships",
    "nav.orders": "Orders",
    "nav.crawler": "Content Collection",
    "nav.analytics": "Analytics",
    "nav.settings": "Settings",
    "nav.admin-users": "Admin Users",
    "sign-out": "Sign Out",
    theme: "Theme",
    "light-mode": "Light",
    "dark-mode": "Dark",
    "system-mode": "System",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    saving: "Saving...",

    // Sections
    "sections.title": "Sections",
    "sections.desc": "Manage community discussion sections",
    "sections.add": "New Section",
    "sections.create": "Create",
    "sections.edit": "Edit Section",
    "sections.name": "Name",
    "sections.slug": "Slug",
    "sections.slug-readonly": "Slug cannot be changed after creation",
    "sections.description": "Description",
    "sections.description-placeholder": "Short description of this section...",
    "sections.sort-order": "Sort Order",
    "sections.no-desc": "No description",
    "sections.empty": "No sections yet. Click to create one.",
    "sections.name-slug-required": "Name and slug are required",
    "sections.created": "Section created",
    "sections.updated": "Section updated",
    "sections.deleted": "Section deleted",
    "sections.create-failed": "Failed to create section",
    "sections.update-failed": "Failed to update section",
    "sections.delete-failed": "Failed to delete section",
    "sections.delete-title": "Delete this section?",
    "sections.delete-desc":
      "This action cannot be undone. Posts in this section will not be deleted.",
    "sections.default-section": "Default Section",
    "sections.select-placeholder": "Select section (optional)",
    "sections.none": "None",
    edit: "Edit",
    create: "Create",
    search: "Search",
    confirm: "Confirm",
    actions: "Actions",
    status: "Status",
    refresh: "Refresh",

    // Login
    "login.title": "Admin Panel",
    "login.description": "Enter admin credentials to continue",
    "login.email": "Email",
    "login.email-placeholder": "Enter your email",
    "login.password": "Password",
    "login.password-placeholder": "Enter your password",
    "login.sign-in": "Sign In",
    "login.signing-in": "Signing in...",
    "login.error-required": "Please enter email and password",
    "login.error-failed": "Login failed",

    // Dashboard
    dashboard: "Dashboard",
    "dashboard.total-users": "Total Users",
    "dashboard.total-posts": "Total Posts",
    "dashboard.admin-count": "Admin Count",
    "dashboard.pending-review": "Pending Review",
    "dashboard.active-subs": "Active Subscriptions",
    "dashboard.total-orders": "Total Orders",
    "dashboard.pending-orders": "Pending Orders",
    "dashboard.mrr": "Monthly Recurring Revenue",
    "dashboard.today-pv": "Today PV",
    "dashboard.crawler-sources": "Crawler Sources",
    "dashboard.platform-live-overview": "Platform Live Overview",
    "dashboard.site": "Site",
    "dashboard.desktop": "Desktop",
    "dashboard.community": "Community",
    "dashboard.today-visits": "Today Visits",
    "dashboard.unique-ip": "Unique IP",
    "dashboard.active-users": "Active Users",
    "dashboard.launch-count": "Launches",
    "dashboard.sessions": "Sessions",
    "dashboard.registered": "Registered",
    "dashboard.anonymous": "Anonymous",
    "dashboard.recent-community-posts": "Recent Community Posts",
    "dashboard.view-all": "View All",
    "dashboard.no-community-posts": "No community posts yet",
    "dashboard.recent-orders": "Recent Orders",
    "dashboard.recent-actions": "Recent Actions",
    "dashboard.no-orders": "No orders yet",
    "dashboard.no-actions": "No actions yet",
    "dashboard.last-5": "Last 5",
    "dashboard.last-10": "Last 10",
    "dashboard.no-admin-actions": "No admin actions recorded",

    // Community Users
    "community.users.title": "User Management",
    "community.users.search-placeholder": "Search by username or email...",
    "community.users.status": "Status",
    "community.users.all": "All",
    "community.users.active": "Active",
    "community.users.banned": "Banned",
    "community.users.inactive": "Inactive",
    "community.users.ban": "Ban",
    "community.users.unban": "Unban",
    "community.users.edit": "Edit User",
    "community.users.role": "Role",
    "community.users.detail": "User Detail",
    "community.users.table-user": "User",
    "community.users.table-email": "Email",
    "community.users.table-role": "Role",
    "community.users.table-status": "Status",
    "community.users.table-posts": "Posts",
    "community.users.table-last-active": "Last Active",
    "community.users.table-actions": "Actions",
    "community.users.no-users": "No users found",
    "community.users.no-users-search": "Try a different search term",
    "community.users.no-users-yet": "No users registered yet",
    "community.users.pagination":
      "Page {{page}} of {{pages}} ({{total}} total)",
    "community.users.detail-title": "User Details",
    "community.users.detail-role": "Role:",
    "community.users.detail-status": "Status:",
    "community.users.detail-posts": "Posts:",
    "community.users.detail-joined": "Joined:",
    "community.users.detail-bio": "Bio",
    "community.users.detail-last-active": "Last active:",
    "community.users.detail-never": "Never",
    "community.users.ban-title": "Ban User",
    "community.users.ban-description": "Ban {name} from the community.",
    "community.users.ban-duration": "Duration (hours)",
    "community.users.ban-duration-hint": "Set to 0 for permanent ban",
    "community.users.ban-reason": "Reason",
    "community.users.ban-reason-placeholder": "Enter reason for ban...",
    "community.users.ban-button": "Ban User",
    "community.users.banning": "Banning...",
    "community.users.ban-success": "User banned successfully",
    "community.users.ban-failed": "Failed to ban user",
    "community.users.unban-success": "User unbanned successfully",
    "community.users.unban-failed": "Failed to unban user",
    "community.users.load-failed": "Failed to load users",
    "community.users.load-failed-desc":
      "An error occurred while fetching users",

    // Community Posts
    "community.posts.title": "Post Management",
    "community.posts.search-placeholder": "Search by title...",
    "community.posts.all-status": "All Status",
    "community.posts.all-sources": "All Sources",
    "community.posts.source-user": "User",
    "community.posts.source-crawler": "Collection",
    "community.posts.tag-placeholder": "Tag...",
    "community.posts.table-title": "Title",
    "community.posts.table-author": "Author",
    "community.posts.table-tags": "Tags",
    "community.posts.table-source": "Source",
    "community.posts.table-status": "Status",
    "community.posts.table-comments": "Comments",
    "community.posts.table-date": "Date",
    "community.posts.table-actions": "Actions",
    "community.posts.published": "Published",
    "community.posts.pending": "Pending Review",
    "community.posts.hidden": "Hidden",
    "community.posts.deleted": "Deleted",
    "community.posts.no-posts": "No posts found",
    "community.posts.no-posts-search": "Try a different search term",
    "community.posts.no-posts-yet": "No posts created yet",
    "community.posts.pagination":
      "Page {{page}} of {{pages}} ({{total}} total)",
    "community.posts.delete-selected": "Delete Selected ({{count}})",
    "community.posts.delete": "Delete",
    "community.posts.batch-delete": "Batch Delete",
    "community.posts.notify-author": "Notify Author",
    "community.posts.reason": "Reason",
    "community.posts.deleting": "Deleting...",
    "community.posts.delete-title": "Delete Post",
    "community.posts.delete-desc":
      "Are you sure you want to delete this post? This action cannot be undone.",
    "community.posts.delete-reason": "Reason (optional)",
    "community.posts.delete-reason-placeholder": "Enter reason for deletion...",
    "community.posts.delete-button": "Delete Post",
    "community.posts.approve": "Approve",
    "community.posts.reject": "Reject",
    "community.posts.content": "Content",
    "community.posts.no-content": "No content available",
    "community.posts.comments": "Comments ({{count}})",
    "community.posts.posted": "Posted",
    "community.posts.untitled": "Untitled",
    "community.posts.deleted-success": "Post deleted",
    "community.posts.delete-failed": "Failed to delete post",
    "community.posts.batch-deleted": "Deleted {{count}} posts",
    "community.posts.batch-delete-failed": "Failed to delete some posts",

    // Memberships
    "memberships.title": "Membership Plans",
    "memberships.create": "New Plan",
    "memberships.edit": "Edit Plan",
    "memberships.name": "Name",
    "memberships.description": "Description",
    "memberships.monthly": "Monthly",
    "memberships.quarterly": "Quarterly",
    "memberships.yearly": "Yearly",
    "memberships.features": "Features",
    "memberships.sort": "Sort Order",
    "memberships.created-success": "Plan created successfully",
    "memberships.updated-success": "Plan updated successfully",
    "memberships.deleted-success": "Plan deleted",
    "memberships.name-required": "Plan name is required",
    "memberships.new-plan": "New Plan",
    "memberships.no-plans": "No plans configured",
    "memberships.create-first": "Create your first membership plan",
    "memberships.edit-title": "Edit Plan",
    "memberships.create-title": "Create Plan",
    "memberships.edit-desc": "Update the membership plan details.",
    "memberships.create-desc": "Add a new membership plan.",
    "memberships.name-label": "Plan Name",
    "memberships.desc-label": "Description",
    "memberships.desc-placeholder": "Brief description of the plan...",
    "memberships.monthly-label": "Monthly Price",
    "memberships.quarterly-label": "Quarterly Price",
    "memberships.yearly-label": "Yearly Price",
    "memberships.sort-label": "Sort: {{value}}",
    "memberships.sort-label-form": "Sort Order",
    "memberships.features-label": "Features",
    "memberships.features-placeholder": "Comma-separated, e.g. HD,Ad-free",
    "memberships.saving": "Saving...",
    "memberships.update-plan": "Update Plan",
    "memberships.create-plan": "Create Plan",
    "memberships.delete-title": "Delete Plan",
    "memberships.delete-desc":
      "Are you sure you want to delete this plan? This action cannot be undone.",
    "memberships.deleting": "Deleting...",
    "memberships.delete-plan": "Delete Plan",

    // Orders
    "orders.title": "Order Management",
    "orders.all-status": "All Status",
    "orders.order-id": "Order ID",
    "orders.user": "User",
    "orders.plan": "Plan",
    "orders.amount": "Amount",
    "orders.payment": "Payment",
    "orders.date": "Date",
    "orders.pending": "Pending",
    "orders.paid": "Paid",
    "orders.failed": "Failed",
    "orders.refunded": "Refunded",
    "orders.no-orders": "No orders found",
    "orders.no-orders-desc":
      "Orders will appear here once customers start purchasing",
    "orders.pagination": "Page {{page}} of {{pages}} ({{total}} total)",
    "orders.refund": "Refund",
    "orders.refund-title": "Refund Order",
    "orders.refund-desc":
      "Are you sure you want to refund this order? The amount will be returned to the customer.",
    "orders.refunding": "Refunding...",
    "orders.confirm-refund": "Confirm Refund",
    "orders.refund-success": "Order refunded successfully",
    "orders.refund-failed": "Failed to refund order",
    "orders.detail-title": "Order Details",
    "orders.detail-order-id": "Order ID",
    "orders.detail-user-id": "User ID",
    "orders.detail-subscription": "Subscription ID",
    "orders.detail-gateway": "Gateway TX ID",
    "orders.detail-amount": "Amount",
    "orders.detail-payment": "Payment Method",
    "orders.detail-metadata": "Metadata",

    // Crawler
    "crawler.title": "Content Collection",
    "crawler.add": "Add Source",
    "crawler.add-source": "Add Source",
    "crawler.edit-source": "Edit Source",
    "crawler.add-desc": "Add a new RSS/website source for collection.",
    "crawler.edit-desc": "Update the collection source configuration.",
    "crawler.all-sources": "All Sources",
    "crawler.enabled": "Enabled",
    "crawler.disabled": "Disabled",
    "crawler.no-sources": "No collection sources configured",
    "crawler.no-sources-desc":
      "Add your first RSS/website source to start collection",
    "crawler.run": "Run Now",
    "crawler.name": "Name",
    "crawler.name-placeholder": "My Blog",
    "crawler.site-url": "Site URL",
    "crawler.site-url-placeholder": "https://example.com",
    "crawler.rss-url": "RSS URL",
    "crawler.rss-url-placeholder": "https://example.com/feed.xml",
    "crawler.cron": "Cron Schedule",
    "crawler.cron-placeholder": "0 */6 * * *",
    "crawler.cron-hint":
      'Standard cron expression (e.g. "0 */6 * * *" for every 6 hours)',
    "crawler.tags": "Tags",
    "crawler.tags-comma": "Tags",
    "crawler.tags-placeholder": "tech, AI, news",
    "crawler.auto-publish": "Auto Publish",
    "crawler.auto-publish-label": "Auto-publish collected posts",
    "crawler.not-run": "Not run yet",
    "crawler.last-run": "Last run:",
    "crawler.failed-run": "Failed:",
    "crawler.create-source": "Create Source",
    "crawler.update-source": "Update Source",
    "crawler.saving": "Saving...",
    "crawler.delete-source": "Delete Source",
    "crawler.delete-title": "Delete Source",
    "crawler.delete-desc":
      "Are you sure you want to delete this collection source? This action cannot be undone.",
    "crawler.deleting": "Deleting...",
    "crawler.created": "Source created",
    "crawler.create-failed": "Failed to create source",
    "crawler.deleted": "Source deleted",
    "crawler.delete-failed": "Failed to delete source",
    "crawler.started": "Crawl started",
    "crawler.start-failed": "Failed to start crawl",
    "crawler.updated": "Source updated",
    "crawler.update-failed": "Failed to update source",
    "crawler.toggle-failed": "Failed to toggle",
    "crawler.name-required": "Source name is required",
    "crawler.total-sources": "Total Sources",
    "crawler.enabled-sources": "Enabled Sources",
    "crawler.scheduled-next-24h": "Scheduled in 24h",
    "crawler.auto-publish-count": "Auto-publish Sources",
    "crawler.scheduler-jobs": "Scheduler Jobs",
    "crawler.status-overview": "Status Overview",
    "crawler.status-running": "Running",
    "crawler.status-success": "Success",
    "crawler.status-failed": "Failed",
    "crawler.status-never": "Not Run",
    "crawler.scheduler-status": "Scheduler",
    "crawler.running": "Running",
    "crawler.stopped": "Stopped",
    "crawler.cron-validity": "Valid Cron",
    "crawler.upcoming-runs": "Upcoming Runs",
    "crawler.no-upcoming-runs": "No upcoming runs",
    "crawler.injected-posts": "Recent Injected Community Posts",
    "crawler.no-injected-posts": "No collection-injected posts yet",
    "crawler.open-community": "Open Community",
    "crawler.run-and-open": "Run and Open Community",
    "crawler.biz-jobs": "Collection Jobs",
    "crawler.no-jobs": "No business jobs available",
    "crawler.add-job": "New Job",
    "crawler.edit-job": "Edit Job",
    "crawler.job-created": "Job created",
    "crawler.job-deleted": "Job deleted",
    "crawler.job-create-failed": "Failed to create job",
    "crawler.job-delete-failed": "Failed to delete job",
    "crawler.delete-job-title": "Delete this job?",
    "crawler.delete-job-desc": "This action cannot be undone.",
    "crawler.description": "Description",
    "crawler.description-placeholder": "Optional notes about this job",
    "crawler.save-schedule": "Save Schedule",
    "crawler.view-last-post": "View Last Result",
    "crawler.cron-required": "Cron expression is required",
    "crawler.section-usage": "Collected News by Section",
    "crawler.section-usage-desc":
      "Based on latest {{count}} collection-injected posts",
    "crawler.no-section-usage": "No section data available yet",
    "crawler.section-unassigned": "Unassigned",
    "crawler.source-usage": "Collection Source Distribution",
    "crawler.source-usage-desc":
      "Based on latest {{count}} collection-injected posts",
    "crawler.no-source-usage": "No source data available yet",
    "crawler.source-unknown": "Unknown Source",
    "crawler.section-count-posts": "{{count}} posts",
    "crawler.section-latest": "Latest: ",
    "crawler.job-target-sections": "Related Sections",
    "crawler.job-target-sections-empty": "No recognized sections yet",
    "crawler.job-strategy-tip":
      "Strategy: the job will publish directly to selected sections; if none selected, it defaults to Engineering.",
    "crawler.job-target-sections-edit": "Click sections below to edit:",
    "crawler.job-target-sections-loading": "Loading community sections...",
    "crawler.save-target-sections": "Save Sections",
    "crawler.select-all-sections": "Select All",
    "crawler.clear-sections": "Clear",

    // Analytics
    "analytics.title": "Analytics",
    "analytics.total-pv": "Total PV",
    "analytics.total-downloads": "Total Downloads",
    "analytics.pv-today": "PV Today",
    "analytics.downloads-today": "Downloads Today",
    "analytics.page-views": "Page Views",
    "analytics.downloads": "Downloads",
    "analytics.top-pages": "Top Pages",
    "analytics.sources": "Sources",
    "analytics.daily-pv": "Daily Page Views",
    "analytics.no-data": "No data available",
    "analytics.no-download-data": "No download data",
    "analytics.traffic-sources": "Traffic Sources",
    "analytics.downloads-by-platform": "Downloads by Platform",
    "analytics.downloads-by-day": "Downloads by Day",

    // Settings
    "settings.title": "System Settings",
    "settings.save": "Save Settings",
    "settings.saved": "Settings Saved",
    "settings.saving": "Saving...",
    "settings.save-changes": "Save Changes",
    "settings.load-failed": "Failed to load settings",
    "settings.site": "Site Settings",
    "settings.site-name": "Site Name",
    "settings.site-name-placeholder": "Sven Studio",
    "settings.registration": "User Registration",
    "settings.registration-desc": "Allow new users to register",
    "settings.review": "Post Review",
    "settings.review-desc": "Require admin review before publishing",
    "settings.email": "Email Settings",
    "settings.email-title": "Email (SMTP) Settings",
    "settings.smtp-host": "SMTP Host",
    "settings.smtp-host-placeholder": "smtp.example.com",
    "settings.smtp-port": "SMTP Port",
    "settings.smtp-user": "SMTP Username",
    "settings.smtp-user-placeholder": "user@example.com",
    "settings.smtp-pass": "SMTP Password",
    "settings.smtp-pass-placeholder": "Enter password",
    "settings.from-address": "From Address",
    "settings.from-address-placeholder": "noreply@example.com",
  },
};

i18n.use(initReactI18next).init({
  resources: { zh, en },
  lng: stored.startsWith("en") ? "en" : "zh",
  fallbackLng: "zh",
  interpolation: { escapeValue: false },
});

export default i18n;
